import { Table } from '@tiptap/extension-table';
import { TableCell } from '@tiptap/extension-table-cell';
import { TableHeader } from '@tiptap/extension-table-header';
import { TableRow } from '@tiptap/extension-table-row';
import { TableActiveCell } from './table-active-cell';

// Inline styles so borders and header background survive email clients that strip external CSS.
// Hex values mirror the gray-4/gray-5 design tokens in rich-text.css; keep in sync if they change.
const TABLE_STYLE = 'border-collapse: collapse; table-layout: fixed; margin: 0';
const CELL_STYLE = 'border: 1px solid #e1e1e0; padding: 4px 8px; vertical-align: top';
const HEADER_STYLE = `${CELL_STYLE}; background-color: #f7f7f7; font-weight: 600; text-align: left`;

export const buildTableExtensions = () => [
  Table.configure({
    resizable: true,
    HTMLAttributes: {
      border: '1',
      cellpadding: '0',
      cellspacing: '0',
      style: TABLE_STYLE,
    },
  }),
  TableRow,
  TableHeader.configure({ HTMLAttributes: { style: HEADER_STYLE, bgcolor: '#f7f7f7' } }),
  TableCell.configure({ HTMLAttributes: { style: CELL_STYLE } }),
  TableActiveCell,
];
